/**
* 基础菜单 系统消息
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <div class="adjuster">
      <!-- 搜索筛选 -->
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="">
          <el-date-picker
            v-model="formDate"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="formInline.message_word" clearable placeholder="输入消息关键字"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="formInline.message_type" placeholder="请选择消息类型" clearable>
            <el-option label="对公转账审核" value="2198"></el-option>
            <el-option label="售后单审核" value="2200"></el-option>
            <el-option label="对公转账退款" value="2199"></el-option>
            <el-option label="开票申请" value="2201"></el-option>
            <el-option label="商品售罄" value="2202"></el-option>
            <el-option label="商品下架" value="2203"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="formInline.handler_status" placeholder="请选择处理状态" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="未处理" value="0"></el-option>
            <el-option label="已处理" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>

      <div style="min-height: 510px;overflow-y: auto">
        <div v-if="sfvalue"><el-empty :image-size="200"></el-empty></div>
        <div class="content">
          <div class="flex_box flex_wrap">
            <div class="item mr80" v-for="(item , index) in tableDataList" :key="index">
              <template slot-scope="scope">
                {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
              </template>
              <div class="ahead flex_box">
                <div class="flex_box">
                  <p class="fw500 f16 color409EFF mr10">{{ item.message_title }}</p>
                  <template class="status">
                    <el-button size="mini" type="danger" round v-if="item.handler_status=='0'">未处理</el-button>
                    <el-button size="mini" type="warning" round v-else>已处理</el-button>
                  </template>
                </div>
                <div>
                  <p class="f12 lh20 color666">{{ item.create_time }}</p>
                </div>
              </div>
              <div class="Below pr">
                <div class="information" @dblclick="copy(item.message_content)">
                  <p class="f14 lh24">{{ item.message_content }}</p>
                </div>
                <div class="messaging_button" v-if="item.handler_status == 0">
                    <el-button type="primary" size="small" @click="edit(item.id)">消息处理</el-button>
                </div>
                <div class="processing_results" v-else>
                  <div class="flex_between">
                    <p class="w150 over_text_1">处理人：{{ item.handler_username }}</p>
                    <p class="w200">处理时间：{{ item.handler_time }}</p>
                  </div>
                  <p class="over_text_1" :title="item.remark">
                    处理内容：{{ item.remark }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
                 :title="dialogTitle" :before-close="closeDialog"
                 :visible.sync="editDialogVisible"
                 width="33%"
                 center>
        <el-form label-width="120px" :model="serviceForm" :rules="rules" ref="serviceForm" class="serviceForm">
          <el-form-item label="处理内容" prop="remark">
            <el-input type="textarea" v-model="serviceForm.remark" class="textarea" placeholder="请输入回复内容"
                      clearable  maxlength="200" :autosize="{ minRows: 4, maxRows: 10}"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="sure('serviceForm')">确 定</el-button>
            <el-button @click="closeDialog">取 消</el-button>
      </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import {
    systemMessageHand,
    systemMessageList
  } from '../../api/basisMG';
  import {timestampToDate} from "../../utils/util";
  import Pagination from '../../components/Pagination';
  import {param} from '../../api/commonMG';

  export default {
    data: () => {
      return {
        loading: false, //是显示加载
        dialogTitle: '',
        editDialogVisible: false,
        tableDataList: [],
        formInline: {
          page: 1,
          rows: 10,
          message_word: '',
          message_type: '',
          handler_status: '0',
          start_create_time: '',
          end_create_time: '',
        },
        serviceForm: {
          id: '',
          remark: '',
        },
        // rules表单验证
        rules: {
          remark: [{required: true, message: '请输入回复内容', trigger: 'blur'}],
        },
        formDate: '',
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        sfvalue: false,
        orderId: '',
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        systemMessageList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.tableDataList = res.content.rows;
              if (res.content.rows) {
                if (res.content.total == 0) {
                  this.sfvalue = true
                } else {
                  this.sfvalue = false
                }
              }
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 消息处理弹窗
      edit(id) {
        console.log(id)
        this.orderId = id;
        this.editDialogVisible = true;
        this.dialogTitle = '消息处理';
        this.serviceForm = {};
      },
      // 确 定
      sure(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.serviceForm.id = this.orderId;
            systemMessageHand(this.serviceForm)
              .then(res => {
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '您已成功处理系统消息!'
                  })
                  this.editDialogVisible = false;
                  this.getdata(this.formInline)
                }
              })
              .catch(err => {
                this.$message.error('网络错误，请稍后再试!')
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editDialogVisible = false
        this.$refs["serviceForm"].resetFields();
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.order_code == cell.innerText || row.message_content == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
      // 点击复制
      copy(name, phone, addr) {
        let url = name
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
          message: '复制成功',
          type: 'success'
        });
        oInput.remove()
      },
      // 搜索事件
      search() {
        if (this.formDate) {
          this.formInline.start_create_time = timestampToDate(this.formDate[0])
          this.formInline.end_create_time = timestampToDate(this.formDate[1])
        } else {
          this.formInline.start_create_time = ''
          this.formInline.end_create_time = ''
        }
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
    height: calc(100% - 60px);
    border-radius: 8px;
    overflow: auto;
  }

  /deep/ .textarea .el-textarea__inner {
    height: 150px;
    width: 407px;
    resize: none;
  }

  .w150 {
    width: 150px;
  }
  .w200 {
    width: 200px;
  }

  .mr10 {
    margin-right: 10px;
  }

  .mr80 {
    margin-right: 80px;
  }

  .f12 {
    font-size: 12px;
  }

  .f14 {
    font-size: 12px;
  }

  .f16 {
    font-size: 16px;
  }

  .fw500 {
    font-weight: 500;
  }

  .color409EFF {
    color: #409EFF;
  }

  .color666 {
    color: #666666;
  }

  .lh20 {
    line-height: 20px;
  }

  .lh24 {
    line-height: 24px;
  }

  .label {
    width: 120px;
    height: 40px;
    line-height: 40px;
    background: #F5F7FA;
    padding-left: 12px;
  }


  /deep/ .textarea textarea {
    resize: none;
    width: 300px;
  }

  .adjuster {
    margin: 30px 0 0 36px;
  }

  .item {
    width: 420px;
    height: 172px;
    border-radius: 8px;
    margin-bottom: 50px;
  }

  .ahead {
    width: 396px;
    height: 23px;
    background: #F5F7FA;
    padding: 8px 12px 9px 12px;
    justify-content: space-between;
    align-items: center;
    box-shadow: inset 0px -1px 0px #EBEEF5;
    border-radius: 8px 8px 0px 0px;
    border: 1px solid #EBEEF5;
    border-bottom: 0;
  }

  .status {
    padding: 1px 9px;
    border: 1px solid #FF5757;
    border-radius: 10px;
  }

  .pr {
    position: relative;
  }

  .Below {
    width: 420px;
    height: 132px;
    border: 1px solid #EBEEF5;
    border-top: 0;
  }

  .information {
    position: absolute;
    width: 400px;
    height: 48px;
    top: 15px;
    left: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .messaging_button {
    position: absolute;
    width: 400px;
    top: 73px;
    left: 15px;
    text-align: center;
  }

  .processing_results {
    position: absolute;
    width: 400px;
    height: 40px;
    top: 73px;
    left: 15px;
  }

  .processing_results p {
    font-weight: 400;
    font-size: 10px;
    line-height: 20px;
    color: #666666;
  }

  .flex_between {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  /deep/ .el-textarea {
    width: 407px;
  }

  /deep/ .el-button--mini, .el-button--mini.is-round {
    padding: 4px 10px;
  }

</style>





// WEBPACK FOOTER //
// src/views/system/systemMessages.vue